import { IAccount } from '@models';
import {
  GETTING_ACCOUNTS,
  GOT_ACCOUNTS,
  IAccountsActions,
} from '@store/types/account';
import { getAccounts as getAccountsRequest } from '@services/accounts';

export const getAccounts = (): any => {
  return (dispatch: (action: IAccountsActions) => void) => {
    dispatch({ type: GETTING_ACCOUNTS });
    getAccountsRequest()
      .then((accounts: IAccount[]) =>
        dispatch({ type: GOT_ACCOUNTS, payload: accounts })
      )
      .catch(() => {});
  };
};
